import type { TrainPart } from '../reducers/wagonSlice'

export type IntervalQuery = {
  index?: number
  station?: string
  direction?: 'leave' | 'arrive'
}

const toSearchString = (query: IntervalQuery): string => {
  const params = new URLSearchParams()

  if (query.index !== undefined) {
    params.set('index', String(query.index))
  }

  if (query.station) {
    params.set('station', query.station)
  }

  if (query.direction) {
    params.set('direction', query.direction)
  }

  const search = params.toString()
  return search ? `?${search}` : ''
}

export const parseIntervalQuery = (search: string): IntervalQuery => {
  if (!search) {
    return {}
  }

  const params = new URLSearchParams(search)
  const indexParam = params.get('index')
  const station = params.get('station') || undefined
  const direction = params.get('direction')

  if (direction !== 'leave' && direction !== 'arrive') {
    if (indexParam === null) {
      return {}
    }
    return { index: Number(indexParam) }
  }

  return { station, direction }
}

export const buildPunctualityPath = (
  date: string,
  trainNumber: string,
  query?: IntervalQuery
): string => {
  const basePath = `/punctuality/${date}/${trainNumber}`
  return query ? `${basePath}${toSearchString(query)}` : basePath
}

export const resolveIntervalFromQuery = (
  search: string,
  trainParts: TrainPart[]
): number | null => {
  if (!trainParts || trainParts.length === 0) {
    return null
  }

  const query = parseIntervalQuery(search)

  if (query.index) {
    const foundPart = trainParts[query.index]
    if (foundPart) {
      return query.index
    }
  }

  if (query.station && query.direction === 'leave') {
    const matchIndex = trainParts.findIndex(
      (trainPart) => trainPart.departureInfraPoint.shortCode === query.station
    )
    if (matchIndex !== -1) {
      return matchIndex
    }
  }

  if (query.station && query.direction === 'arrive') {
    const matchIndex = trainParts.findLastIndex(
      (trainPart) => trainPart.arrivalInfraPoint.shortCode === query.station
    )
    if (matchIndex !== -1) {
      return matchIndex
    }
  }

  return 0
}
